import { useVisibilityObserver } from '@ktag/styleguide/dist/react';
import classNames from 'classnames';
import React, { useRef } from 'react';
import * as uniqid from 'uniqid';

interface Props {
  isFinal?: boolean;
  value: number;
  maxValue: number;
  elected?: boolean;
  resultString: string;
  screenReaderAppendix?: string;
  small?: boolean;
}

const RaceBar = ({
  isFinal,
  value,
  maxValue,
  elected,
  resultString,
  screenReaderAppendix,
  small,
}: Props) => {
  const candidateBarRef = useRef<HTMLDivElement>();
  const isVisible = useVisibilityObserver(candidateBarRef);
  const width = (value / maxValue) * 100 || 0;
  const style = { '--width': `${width}%` } as React.CSSProperties;

  const key = useRef<string>(uniqid());

  return (
    <div className={classNames('racebar', { 'racebar--small': small })}>
      <div
        className={classNames('racebar__bar', {
          'racebar__bar--animated': isVisible,
          'racebar__bar--elected': isFinal && elected,
          'racebar__bar--not-elected': isFinal && !elected,
        })}
        ref={candidateBarRef}
        style={style}
        key={key.current}
      >
        <div className="racebar__votes">
          {resultString}
          {screenReaderAppendix && (
            <span className="racebar__visuallyhidden">{`\u00A0${screenReaderAppendix}`}</span>
          )}
        </div>
      </div>
    </div>
  );
};

RaceBar.defaultProps = {
  elected: true,
  isFinal: false,
};

export default RaceBar;
